module.exports = __webpack_public_path__ + "static/media/plus-alt.b5ec1162.svg";